import { render, staticRenderFns } from "./webFirst.vue?vue&type=template&id=c22c8bd8&scoped=true&"
import script from "./webFirst.vue?vue&type=script&lang=js&"
export * from "./webFirst.vue?vue&type=script&lang=js&"
import style0 from "./webFirst.vue?vue&type=style&index=0&id=c22c8bd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22c8bd8",
  null
  
)

export default component.exports